import { render, staticRenderFns } from "./ClassificacaoEditar.vue?vue&type=template&id=5c6f03c1"
import script from "./ClassificacaoEditar.vue?vue&type=script&lang=js"
export * from "./ClassificacaoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports